import React from "react";
import styled from "styled-components";

const StyledDocument = styled.img`
  display: none;
  height: 70px;
  width: fit-content;
  background-color: #000;
  border-radius: 10px;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const StyledDescription = styled.div`
  width: 100%;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme }) => theme.white + 99};
  margin-bottom: 10px;
  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

const StyledSpan = styled.span`
  overflow: hidden;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`;

const StyledCard = styled.div`
  width: 650px;
  border-radius: 10px;
  padding: 12px 16px;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.3s ease-in-out;
  &:hover {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
    transform: translateY(-5px);
  }
  @media only screen and (max-width: 768px) {
    padding: 10px;
    gap: 8px;
    width: 300px;
  }

  &:hover ${StyledDocument} {
    display: flex;
  }

  &:hover ${StyledSpan} {
    overflow: visible;
    -webkit-line-clamp: unset;
  }
  border: 0.1px solid #58003d;
  box-shadow: rgba(230, 23, 85, 0.15) 0px 4px 24px;
`;

const StyledTop = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
`;

const StyledBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledName = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.white + 99};
  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

const StyledDegree = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.white + 99};
  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

const StyledDate = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.white + 85};
  @media only screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

const EducationCard = ({ education }) => {
  return (
    <StyledCard>
      <StyledTop>
        <StyledBody>
          <StyledName>{education.school}</StyledName>
          <StyledDegree>{education.degree}</StyledDegree>
          <StyledDate>{education.date}</StyledDate>
        </StyledBody>
      </StyledTop>
      <StyledDescription>
        <StyledSpan>{education.desc}</StyledSpan>
      </StyledDescription>
    </StyledCard>
  );
};

export default EducationCard;
